import { Container, Grid, Paper, Typography, Link } from '@mui/material'
import { styled } from '@mui/material/styles'
import React from 'react'
import config from '../config'
import MobileMenu from './layout/mobilemenu.component'
import AppStoreButton from './layout/appstore.component'
import { useLocation } from 'react-router-dom'

const PREFIX = 'Maintenance'

const classes = {
  root: `${PREFIX}-root`,
  rootContainer: `${PREFIX}-root-container`,
  container: `${PREFIX}-container`,
  title: `${PREFIX}-title`,
  gridContainer: `${PREFIX}-grid-container`,
  paper: `${PREFIX}-paper`,
  paperInner: `${PREFIX}-paper-inner`,
  logo: `${PREFIX}-logo`,
  buttonContainer: `${PREFIX}-button-container`,
  subTitle: `${PREFIX}-subtitle`,
  text: `${PREFIX}-text`,
  tips: `${PREFIX}-tips`,
}
const Root = styled('div')(({ theme }) => ({
  [`& .${classes.root}`]: {
    display: 'flex',
    flexDirection: 'column',
  },
  [`& .${classes.rootContainer}`]: {
    maxWidth: '100%',
    flexGrow: '1 0 auto',
    minHeight: 'calc(100vh - 125px)',
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(4, 0, 1, 0),
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(8, 6, 1, 6),
    },
  },
  [`& .${classes.gridContainer}`]: {
    flexGrow: 1,
    display: 'flex',
    marginBottom: theme.spacing(1.5),
  },
  [`& .${classes.paper}`]: {
    padding: theme.spacing(6, 2, 2, 2),
    borderRadius: theme.spacing(2),
    marginTop: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      margin: theme.spacing(0, 2),
    },
  },
  [`& .${classes.logo}`]: {
    height: theme.spacing(5),
    verticalAlign: 'middle',
    marginLeft: theme.spacing(1),
  },
  [`& .${classes.buttonContainer}`]: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
    textAlign: 'center',
    padding: '0px 20px',
    [theme.breakpoints.up('lg')]: {
      padding: theme.spacing(0, 4.5),
    },
  },
  [`& .${classes.buttonContainer} > .MuiButtonBase-root`]: {
    marginTop: theme.spacing(0.5),
  },
  [`& .${classes.title}`]: {
    verticalAlign: 'middle',
  },
  [`& .${classes.tips}`]: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(1, 1.5),
    borderRadius: theme.spacing(2),
    display: 'flex',
  },
  [`& .${classes.tips} > img`]: {
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(0),
  },
  [`& .${classes.text}`]: {
    display: 'inline-flex',
    alignItems: 'center',
    fontSize: theme.spacing(1.5),
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.spacing(1.4),
    },
  },
  [theme.breakpoints.up('lg')]: {
    [`& .${classes.buttonContainer} button, .${classes.buttonContainer} a`]: {
      fontSize: theme.spacing(1.85),
    },
  },
}))

function Maintenance() {
  const location = useLocation()
  const { message } = location.state || {}

  return (
    <Root className={classes.root}>
      <div className={classes.rootContainer}>
        <MobileMenu />
        <Grid
          container
          direction="row"
          justifyContent="center"
          className={classes.gridContainer}
        >
          <Grid
            item
            xs={11}
            sm={6}
            md={5}
            lg={3}
            component={Paper}
            elevation={3}
            className={classes.paper}
          >
            <Typography variant="h2" align="center">
              <span className={classes.title}>Welcome to </span>
              <img
                className={classes.logo}
                src={`${config.PUBLIC_URL}/logo.png`}
                alt="logo"
              />
            </Typography>
            <Typography variant="h6" align="center">
              Prepaid Registration
            </Typography>
            <Container className={classes.buttonContainer}>
              <Typography variant="subtitle2" align="center">
                We are currently undergoing system upgrade.
                <br />
                <br />
                {message ? (
                  message
                ) : (
                  <>
                    Please proceed to{' '}
                    <Link
                      href="https://www.m1.com.sg/mobile/prepaid-plans/prepaid-retailers"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Prepaid Retailers
                    </Link>{' '}
                    or the nearest{' '}
                    <Link
                      href="https://www.m1.com.sg/support/contact-us"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      M1 Shop
                    </Link>{' '}
                    to register your SIM.
                    <br />
                    <br />
                    We apologise for any inconvenience caused.
                  </>
                )}
                <br />
                <br />
              </Typography>
            </Container>
            <Container sx={{ textAlign: 'center' }}>
              <Typography className={classes.text}>
                Download M1 Prepaid App to manage your account
                <br />
                <br />
              </Typography>
              <AppStoreButton />
            </Container>
          </Grid>
        </Grid>
        <Grid container direction="row" justifyContent="center">
          <Grid
            item
            xs={11}
            sm={6}
            md={5}
            lg={3}
            component={Paper}
            elevation={3}
            className={classes.tips}
          >
            <img
              className={classes.logo}
              src={`${config.PUBLIC_URL}/device_1.svg`}
              alt="logo"
            />
            <Typography className={classes.text} fontWeight={700}>
              To get the best experience, try registering your new SIM on your
              mobile phone!
            </Typography>
          </Grid>
        </Grid>
      </div>
    </Root>
  )
}

export default Maintenance
